const actions = {
  CREATE_PRODUCTO: 'CREATE_PRODUCTO',
  GET_PRODUCTOS: 'GET_PRODUCTOS',
  GET_OPCIONALES: 'GET_OPCIONALES',
  EDIT_PRODUCTO: 'EDIT_PRODUCTO',
  DELETE_PRODUCTO: 'DELETE_PRODUCTO',
  UPDATE_PRODUCTOS: 'UPDATE_PRODUCTOS',
  UPDATE_OPCIONALES: 'UPDATE_OPCIONALES',
  
  initDataProductos: (params) => ({ type: actions.GET_PRODUCTOS, params }),
  initDataOpcionales: (query) => ({ type: actions.GET_OPCIONALES, query }),
  createProducto: (data, history) => ({
    type: actions.CREATE_PRODUCTO,
    data,
    history
  }),
  editProducto: data => ({
    type: actions.EDIT_PRODUCTO,
    data
  }),
  deleteProducto: id => ({
    type: actions.DELETE_PRODUCTO,
    id
  }),
  
};
export default actions;
